import { ReactNode, useState, MouseEvent } from "react";
import styled from "styled-components/macro";
import classNames from "classnames";
import { ChevronUp } from "./Icons";

const Drawer = styled(function Drawer({
  header,
  defaultOpen = true,
  onClick: originalOnClick,
  children,
  className,
}: {
  header: ReactNode;
  defaultOpen?: boolean;
  onClick?: (e: MouseEvent) => void;
  children: ReactNode;
  className?: string;
}) {
  const [isOpen, setOpen] = useState(defaultOpen);
  const toggle = (e: MouseEvent) => {
    setOpen(!isOpen);
    if (originalOnClick) originalOnClick(e);
  };

  return (
    <Container className={className}>
      <Header onClick={toggle} className={classNames({ open: isOpen })}>
        {header}
        <ChevronUp />
      </Header>
      {isOpen && children}
    </Container>
  );
})``;

const Container = styled.div`
  overflow-x: hidden;
  overflow-y: hidden;
`;

const Header = styled.button`
  border: 0;
  background: transparent;
  display: block;
  width: 100%;
  text-align: left;
  font-size: inherit;
  padding: 0 14px;
  font-family: inherit;
  font-weight: 500;
  color: rgb(103, 103, 103);
  color: inherit;
  line-height: 40px;
  position: relative;
  border-top: 1px solid transparent;
  &:hover {
    background: rgba(0, 0, 0, 0.02);
  }
  &:active {
    background: rgba(0, 0, 0, 0.04);
  }
  ${ChevronUp} {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%) rotateZ(90deg);
    transition-duration: 0.2s;
  }
  ${Container}:not(:first-child) &.open {
    border-bottom: 1px solid #eee;
  }
  &.open ${ChevronUp} {
    transform: translateY(-50%) rotateZ(180deg);
  }
`;

export default Drawer;
